import { useTranslation } from 'react-i18next';
import { API_PATCH, API_POST, DBRequest, useConfig } from '../../../api/api';
import ExoForm from '../../../components/exo/ExoForm';
import { useState } from 'react';
import * as Yup from 'yup';

export const NewProjectCategory = ({ onChange, onClose, startData }) => {
  const { t } = useTranslation();
  const config = useConfig();

  const [isLoading, setIsLoading] = useState(false);

  const fields = [
    {
      label: t('Icon'),
      key: 'icon',
      type: 'icon',
    },
    {
      label: t('Color'),
      key: 'color',
      type: 'color',
    },
    {
      label: t('Name'),
      key: 'label',
      type: 'text',
    },
  ];

  function handleSubmit(data) {
    const isUpdate = Boolean(data.id);

    DBRequest({
      config,
      path: isUpdate ? `project-categories/${data.id}` : `project-categories`,
      method: isUpdate ? API_PATCH(data) : API_POST(data),
      onResponse: (res) => {
        onChange(res);
        onClose();
      },
      onLoading: setIsLoading,
    });
  }

  const validationSchema = Yup.object().shape({
    color: Yup.string().required(t('Color is required')),
    label: Yup.string().required(t('Name is required')),
  });

  return (
    <ExoForm
      isLoading={isLoading}
      fields={fields}
      onSubmit={handleSubmit}
      noDifferences
      onCancel={onClose}
      startDataCollection={startData}
      header={startData?.id ? t('Update Category') : t('New Category')}
      validationSchema={validationSchema}
    />
  );
};
